import { render } from "./BaseBottomButton.vue?vue&type=template&id=32955840&scoped=true&ts=true"
import script from "./BaseBottomButton.vue?vue&type=script&lang=ts"
export * from "./BaseBottomButton.vue?vue&type=script&lang=ts"

import "./BaseBottomButton.vue?vue&type=style&index=0&id=32955840&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32955840"]])

export default __exports__